(ns hai.web-app.util.rf-storage
  "Provides re-frame utilities to store/retrieve from local-storage or other storage backends."
  (:require
   [akiroz.re-frame.storage :as rf-storage]))

(defn settings-local
  "re-frame interceptor which stores certain keys to local-storage.

  Usage:

      (defevent :some/key <-> [(settings-local)]
        [db some-value]
        (assoc-in db [:settings/local :some/key] some-value))

  This will ensure that `db` has latest value from local-storage, and
  any changes to the keys below will also be persisted to
  local-storage.

  Also call this function db initialisation which sets
  all keys below to their value from local-storage.

  Check event: hai.web-app.initialize-db"
  []
  (rf-storage/persist-db-keys
   :web-app/settings.local
   [:settings/local
    :feature-flag/config
    :theme/dark-mode]))
